/* eslint-disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify Platform models and run
 * the export script to regenerate this file.
 */

export interface Models {
  [k: string]: unknown;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AbstractLicensingTokenBase".
 */
export interface AbstractLicensingTokenBase {
  active: boolean;
  created?: number;
  id: string;
  name?: string;
  org_id: string;
  rotated_from?: string;
  token: string;
  token_type: LicensingTokenType;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AcceptInvitationRequest".
 */
export interface AcceptInvitationRequest {
  password?: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AdminChangePrimaryMembershipRequest".
 */
export interface AdminChangePrimaryMembershipRequest {
  org_id: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AdminCreateMembershipRequest".
 */
export interface AdminCreateMembershipRequest {
  auto_assign_license?: boolean;
  permissions?: string[];
  role?: UserRole;
  user_id: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AdminCreateUserRequest".
 */
export interface AdminCreateUserRequest {
  email: string;
  firstname?: string;
  howFound?: UserSource;
  lastname?: string;
  newsletter?: boolean;
  password: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AdminGetOrganizationResponse".
 */
export interface AdminGetOrganizationResponse {
  basic_details: OrganizationBasicDetails;
  billing_details: OrganizationBillingDetails;
  external_links: OrganizationExternalLinks;
  id: string;
  pods_settings: CloudPodsSettings;
  scim_settings: {
    [k: string]: OrganizationSCIMSettings;
  };
  sso_settings: {
    [k: string]: OrganizationSSOSettings;
  };
  tax_details: OrganizationTaxDetails;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "OrganizationBasicDetails".
 */
export interface OrganizationBasicDetails {
  name?: string;
  org_type?: OrganizationType;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "OrganizationBillingDetails".
 */
export interface OrganizationBillingDetails {
  address?: string;
  city?: string;
  country?: string;
  email?: string;
  phone?: string;
  state?: string;
  zip?: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "OrganizationExternalLinks".
 */
export interface OrganizationExternalLinks {
  aws_customer?: string;
  hubspot_company_id?: string;
  namespace_tenant_id?: string;
  stripe_eur_customer?: string;
  stripe_usd_customer?: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "CloudPodsSettings".
 */
export interface CloudPodsSettings {
  auto_cleanup?: CloudPodsAutoCleanup;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "CloudPodsAutoCleanup".
 */
export interface CloudPodsAutoCleanup {
  max_pod_versions?: number;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "OrganizationSCIMSettings".
 */
export interface OrganizationSCIMSettings {
  is_enabled?: boolean;
  role_group_names?: RoleGroupNames;
}
/**
 * IdP-side displayNames for the synthetic admin / member role groups,
 * per IdP. Persisted (rather than echoed per-request) so the same
 * displayName is returned consistently across every SCIM endpoint —
 * no-filter list, filtered list, GET-by-id, POST/PUT/PATCH responses.
 *
 * Auto-captured on the first POST/PUT/PATCH(displayName) the IdP sends.
 * Override semantics: latest IdP push wins (the IdP is the source of
 * truth for what its own groups are called). When the UI feature lands,
 * customers will be able to seed these values, but an IdP push that
 * follows still overwrites them with the same precedence.
 *
 * ``None`` means "fall back to the canonical ``LocalStack-Admin`` /
 * ``LocalStack-Member`` name."
 *
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "RoleGroupNames".
 */
export interface RoleGroupNames {
  admin?: string;
  member?: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "OrganizationSSOSettings".
 */
export interface OrganizationSSOSettings {
  assign_license_on_join?: boolean;
  default_membership_permissions?: string[];
  default_membership_role?: string;
  strict_sso_mode?: boolean;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "OrganizationTaxDetails".
 */
export interface OrganizationTaxDetails {
  tax_id?: string;
  tax_id_type?: TaxIdType;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AdminPatchOrganizationRequest".
 */
export interface AdminPatchOrganizationRequest {
  basic_details?: OrganizationBasicDetails;
  billing_details?: OrganizationBillingDetails;
  external_links?: OrganizationExternalLinks;
  tax_details?: OrganizationTaxDetails;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AdminPatchOrganizationResponse".
 */
export interface AdminPatchOrganizationResponse {
  basic_details: OrganizationBasicDetails;
  billing_details: OrganizationBillingDetails;
  external_links: OrganizationExternalLinks;
  id: string;
  pods_settings: CloudPodsSettings;
  sso_settings: {
    [k: string]: OrganizationSSOSettings;
  };
  tax_details: OrganizationTaxDetails;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AdminSearchResult".
 */
export interface AdminSearchResult {
  extensions: [string, string][];
  keys: [string, string][];
  organizations: [string, string][];
  users: [string, string][];
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AdminUpdateOrganizationRequest".
 */
export interface AdminUpdateOrganizationRequest {
  address?: string;
  aws_customer?: string;
  city?: string;
  country?: string;
  creator?: string;
  email?: string;
  free_beta?: boolean;
  has_custom_terms?: boolean;
  hubspot_company_id?: string;
  name?: string;
  orgType?: OrganizationType;
  phone?: string;
  state?: string;
  tax_id?: string;
  tax_id_type?: TaxIdType;
  tenant_id?: string;
  zip?: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AdminUpdateUserRequest".
 */
export interface AdminUpdateUserRequest {
  firstname?: string;
  free_beta?: boolean;
  hubspot_contact_id?: string;
  lastname?: string;
  name?: string;
  organizations?: string[];
  phone?: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AdminUser".
 */
export interface AdminUser {
  email: string;
  id: string;
  permissions: AdminPermission[];
}
/**
 * Used for CI tokens that resolve to a org but not a user.
 *
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AnonymousOrgClaims".
 */
export interface AnonymousOrgClaims {
  org_id: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AssignableSubscriptionOption".
 */
export interface AssignableSubscriptionOption {
  emulator: EmulatorType;
  plan_family: PlanFamily;
  subscription_id: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AuditTrailEvent".
 */
export interface AuditTrailEvent {
  initiator: AuditTrailInitiator;
  modifications: AuditTrailModifications;
  subject: AuditTrailParty;
  timestamp: number;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AuditTrailInitiator".
 */
export interface AuditTrailInitiator {
  email?: string;
  id?: string;
  name?: string;
  org_id?: string;
  org_name?: string;
  type: AuditTrailInitiatorType;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AuditTrailModifications".
 */
export interface AuditTrailModifications {
  changes: ModelAttributeChange[];
  entity: string;
  entity_data: {
    [k: string]: unknown;
  };
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "ModelAttributeChange".
 */
export interface ModelAttributeChange {
  new_value: unknown;
  old_value: unknown;
  path: string;
  type: string;
}
/**
 * Entity representing a basic party involved in an audit trail event (usually initiator and subject).
 * Note empty strings instead of None(s) here, this is to fix the issue with CW filtering on moto side.
 *
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AuditTrailParty".
 */
export interface AuditTrailParty {
  email?: string;
  id?: string;
  name?: string;
  org_id?: string;
  org_name?: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AuditTrailQueryResult".
 */
export interface AuditTrailQueryResult {
  events: AuditTrailEvent[];
  query_id?: string;
  status: AuditTrailQueryStatus;
}
/**
 * Establishes a link between an auth account(s) (Cognito) and a user account
 *
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AuthLink".
 */
export interface AuthLink {
  id: string;
  link_type: AuthLinkType;
  user_email: string;
  user_id: string;
  user_name: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AuthRequest".
 */
export interface AuthRequest {
  auth_token?: string;
  code: string;
  confirmed?: boolean;
  exchange_token?: string;
  exchanged?: boolean;
  expires_at?: boolean & number;
  id: string;
  initiator?: AuthRequestInitiator;
  user_id?: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AuthRequestInitiator".
 */
export interface AuthRequestInitiator {
  actor?: string;
  version?: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AuthToken".
 */
export interface AuthToken {
  metadata?: {
    [k: string]: unknown;
  };
  token: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AwsMarketplaceProduct".
 */
export interface AwsMarketplaceProduct {
  production_product_code: string;
  related_plan: Plan;
  seats_dimension_id: string;
  staging_product_code: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "Plan".
 */
export interface Plan {
  currency: string;
  discount?: Discount;
  emulator: EmulatorType;
  family: PlanFamily;
  id: string;
  interval_months: number;
  max_duration?: {
    [k: string]: number;
  };
  multi_interval_plan_family?: boolean;
  name: string;
  plan_seat_limit?: number;
  prepaid?: boolean;
  products: Product[];
  provider: SubscriptionProvider;
  public?: boolean;
  subscribable?: boolean;
  supersedes_plan_ids?: string[];
  switchable?: boolean;
  taxable?: string[];
  updatable?: boolean;
  visible?: boolean;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "Discount".
 */
export interface Discount {
  clear_on_cancel?: boolean;
  discount_flat?: number;
  discount_percentage?: number;
  discount_products?: string[];
  duration_months?: number;
  id: string;
  name?: string;
  valid_until?: number;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "Product".
 */
export interface Product {
  description?: string;
  features?: unknown[];
  id: string;
  metered?: boolean;
  name: string;
  price?: number;
  providers: SubscriptionProvider[];
  tax_code?: ProductTaxCode;
  tiers?: Tier[];
  type: ProductType;
  usage_limit?: UsageLimit;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "Tier".
 */
export interface Tier {
  end?: number;
  flat_value?: number;
  item_value?: number;
  start: number;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "UsageLimit".
 */
export interface UsageLimit {
  grace_period_months?: number;
  seat_tiers?: Tier[];
  soft?: boolean;
  static_limit?: number;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AwsMarketplaceSubscriptionEvent".
 */
export interface AwsMarketplaceSubscriptionEvent {
  action: AWSSubscriptionAction;
  aws_customer: string;
  customer_identifier: string;
  id: string;
  is_free_trial_term_present: boolean;
  offer_identifier: string;
  product_code: string;
  status: AwsMarketplaceSubscriptionEventStatus;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "BaseModel".
 */
export type BaseModel = any;
/**
 * Base model for Request Parsing and Validation DTOs.
 *
 * It automatically converts Pydantic errors into GenericUnprocessableError,
 * and communicates back the list of fields that failed validation.
 *
 * In addition to that, the model provides a handy method "is_provided" to figure
 * out fields that actually changed, to ensure values are not replaced with
 * None's/default values if not present in the request at all.
 *
 * IMPORTANT: Use `Model.model_validate({...})` instead of Model(**{}).
 *            Bringing support for that would break type hints.
 *
 * IMPORTANT: All blueprints must be registered before initializing FlaskRequestParser.
 *
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "BaseRequestModel".
 */
export interface BaseRequestModel {}
/**
 * Represents a browsable cloud pod instance, which is a LocalStack instance accessible
 * under a specific endpoint URL, allowing the user to browse the state of a pod.
 *
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "BrowsableCloudPodInstance".
 */
export interface BrowsableCloudPodInstance {
  creation_time: number;
  endpoint_url: string;
  expiry_time: number;
  id: string;
  image: ComputeInstanceImage;
  instance_name: string;
  labels?: {
    [k: string]: string;
  };
  pod_name: string;
  requestor: string;
  shape: ComputeInstanceShape;
  status: EphemeralInstanceStatus;
  version?: number;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "ComputeInstanceImage".
 */
export interface ComputeInstanceImage {
  image_name: SupportedImage;
  tag?: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "ComputeInstanceShape".
 */
export interface ComputeInstanceShape {
  memory_megabytes: 2048 | 4096 | 8192 | 16384 | 32768;
  virtual_cpus: 1 | 2 | 4 | 8 | 16 | 32;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "CIAuthToken".
 */
export interface CIAuthToken {
  active: boolean;
  created?: number;
  id: string;
  name?: string;
  org_id: string;
  revoked_at?: number;
  revoked_reason?: RevokingReason;
  rotated_from?: string;
  subscription_id: string;
  token: string;
  token_type?: LicensingTokenType;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "CIAuthTokenUsage".
 */
export interface CIAuthTokenUsage {
  active: boolean;
  created?: number;
  id: string;
  name?: string;
  org_id: string;
  revoked_at?: number;
  revoked_reason?: RevokingReason;
  rotated_from?: string;
  rotation_history: string[];
  subscription_id: string;
  token: string;
  token_type?: LicensingTokenType;
  usage: number;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "CLIMetadata".
 */
export interface CLIMetadata {
  binaries: PlatformBinaries;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "PlatformBinaries".
 */
export interface PlatformBinaries {
  linux_amd64: PrebuiltBinaryMetadata;
  linux_arm64: PrebuiltBinaryMetadata;
  mac_amd64: PrebuiltBinaryMetadata;
  mac_arm64: PrebuiltBinaryMetadata;
  windows_amd64: PrebuiltBinaryMetadata;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "PrebuiltBinaryMetadata".
 */
export interface PrebuiltBinaryMetadata {
  downloadUrl: string;
  name: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "CachedEntity".
 */
export interface CachedEntity {
  created: number;
  entity: {
    [k: string]: unknown;
  };
  entity_type: string;
  expire_at?: number;
  id: string;
  org_id?: string;
  user_id?: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "CancellationDetails".
 */
export interface CancellationDetails {
  comment?: string;
  feedback?: CancellationFeedback;
  reason?: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "CiKeysUsageSummary".
 */
export interface CiKeysUsageSummary {
  ci_keys_usage_by_date?: {
    [k: string]: UsageRecordDetails;
  };
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "UsageRecordDetails".
 */
export interface UsageRecordDetails {
  key_usage?: {
    [k: string]: number;
  };
  subscription_usage?: {
    [k: string]: number;
  };
  usage_total?: number;
  user_usage?: {
    [k: string]: number;
  };
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "CloudFormationCatalogEntry".
 */
export interface CloudFormationCatalogEntry {
  methods: string[];
}
/**
 * The entity representing a Cloud Pod. It is part of the storage layer.
 *
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "CloudPod".
 */
export interface CloudPod {
  branch?: string;
  encrypted?: boolean;
  id: string;
  is_public?: boolean;
  last_change?: number;
  max_version?: number;
  org_id: string;
  pod_name: string;
  presigned_urls?: CloudPodPresignedUrls;
  storage_size?: number;
  url?: string;
  user_id?: string;
  versions?: CloudPodVersion[];
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "CloudPodPresignedUrls".
 */
export interface CloudPodPresignedUrls {
  state_archive_url?: string;
  versions_archive_url?: string;
}
/**
 * Stores a number of details about a pod version. Part of the storage layer.
 *
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "CloudPodVersion".
 */
export interface CloudPodVersion {
  cloud_control_resources?: string;
  created_at?: number;
  deleted?: boolean;
  description?: string;
  id: string;
  localstack_version?: string;
  pod_id: string;
  services?: string[];
  storage_size?: number;
  user?: string;
  user_id?: string;
  version: number;
}
/**
 * Payload for the pod requests/responses.
 * Note: `versions` and `presigned_urls` meant only for the responses.
 *
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "CloudPodDetails".
 */
export interface CloudPodDetails {
  ci_pod?: {
    [k: string]: unknown;
  };
  cloud_control_resources?: string;
  description?: string;
  encrypted?: boolean;
  localstack_version?: string;
  max_version?: number;
  pod_name?: string;
  presigned_urls?: CloudPodPresignedUrls;
  services?: string[];
  size?: number;
  user_id?: string;
  version?: number;
  versions?: CloudPodVersion[];
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "CloudPodsStats".
 */
export interface CloudPodsStats {
  org_limit?: CloudPodsSummary;
  org_pods?: CloudPodsSummary;
  user_pods?: {
    [k: string]: CloudPodsSummary;
  };
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "CloudPodsSummary".
 */
export interface CloudPodsSummary {
  pods_count?: number;
  storage_size?: number;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "CombinedUserInfo".
 */
export interface CombinedUserInfo {
  features: string[];
  permissions: string[];
  platform_admin?: AdminUser;
  roles: string[];
  user: User;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "User".
 */
export interface User {
  activated?: number;
  activation_key?: string;
  chatToken?: string;
  company?: string;
  created?: number;
  deleted?: boolean | number;
  email: string;
  email_prev?: string;
  firstname?: string;
  free_beta?: boolean;
  github_username?: string;
  how_found?: UserSource;
  hubspot_contact_id?: string;
  id: string;
  job_title?: string;
  last_hst_ts?: number;
  lastname?: string;
  login?: string;
  name: string;
  newsletter?: boolean;
  newsletter_disabled?: boolean;
  organizations?: string[];
  origin?: UserOrigin;
  origin_details?: string;
  phone?: string;
  recovery_info?: RecoveryInfo;
  recovery_key?: string;
  scim_idp_providers?: {
    [k: string]: {
      [k: string]: UserScimIdpProfile;
    };
  };
  settings?: UserSettings;
  signup_survey?: SignupSurvey;
  token?: UserJWTToken;
  tos_acceptance_log?: TosAcceptanceLog;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "RecoveryInfo".
 */
export interface RecoveryInfo {
  recovery_key: string;
  valid_through_utc_timestamp: number;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "UserScimIdpProfile".
 */
export interface UserScimIdpProfile {
  external_id?: string;
  user_name?: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "UserSettings".
 */
export interface UserSettings {
  latest_workspace_id?: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "SignupSurvey".
 */
export interface SignupSurvey {
  create_sub?: boolean;
  emulator?: EmulatorType;
  is_student?: boolean;
  planned_usage_type?: PlannedUsageType;
  promo_code?: string;
  require_finish_account_creation?: boolean;
}
/**
 * A temporary workaround to avoid user_organization module dependency on the auth module.
 * Ideally, user and token should be completely separated.
 *
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "UserJWTToken".
 */
export interface UserJWTToken {
  metadata?: {
    [k: string]: unknown;
  };
  token: string;
}
/**
 * Legacy record of a Terms of Service acceptance made before the current legal framework.
 *
 * These records are no longer written - new acceptances go through LegalAcceptance. The model
 * is retained for read-only access so the original pre-framework acceptance evidence (time,
 * context, IP, user agent) stays viewable and defensible. It is still reachable through
 * User.tos_acceptance_log and the HubSpot fallback in hubspot_integration/adapters.
 *
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "TosAcceptanceLog".
 */
export interface TosAcceptanceLog {
  acceptance_context: string;
  client_ip: string;
  timestamp_utc: number;
  user_agent: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "ComputeTenant".
 */
export interface ComputeTenant {
  id: string;
  org_id: string;
  tenant_name: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "ComputeUsageInformation".
 */
export interface ComputeUsageInformation {
  per_day: {
    [k: string]: ComputeUsageRecord;
  };
  per_sub: {
    [k: string]: ComputeUsageRecord;
  };
  total: ComputeUsageRecord;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "ComputeUsageRecord".
 */
export interface ComputeUsageRecord {
  compute_credits?: number;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "ComputeUsagePolicy".
 */
export interface ComputeUsagePolicy {
  quota: ComputeUsageQuota;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "ComputeUsageQuota".
 */
export interface ComputeUsageQuota {
  compute_credits?: number;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "ComputeUsageSummary".
 */
export interface ComputeUsageSummary {
  policy: ComputeUsagePolicy;
  usage: ComputeUsageInformation;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "CreateAuthRequest".
 */
export interface CreateAuthRequest {
  actor?: string;
  version?: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "CreateCiTokenRequest".
 */
export interface CreateCiTokenRequest {
  name?: string;
  subscription_id: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "CreateInvitationRequest".
 */
export interface CreateInvitationRequest {
  email: string;
  join_settings?: UserInvitationDetails;
  name: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "UserInvitationDetails".
 */
export interface UserInvitationDetails {
  auto_assign_license: boolean;
  permissions: string[];
  role: UserRole;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "CreateInvitationResponse".
 */
export interface CreateInvitationResponse {
  created: number;
  email: string;
  expire_at: number;
  id: string;
  join_settings?: UserInvitationDetails;
  name: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "CreateOrganizationSubscriptionRequest".
 */
export interface CreateOrganizationSubscriptionRequest {
  acquisition_channel?: AcquisitionChannel;
  backdate_start_date?: number;
  billing_channel?: BillingChannel;
  billing_cycle_anchor?: number | string;
  custom_renewal_date?: number;
  customer_id?: string;
  discount?: string;
  interval?: number;
  mrr?: number;
  mrr_private?: number;
  name?: string;
  org_id?: string;
  payment_id?: string;
  plan: string;
  products?: string[];
  promo_code?: string;
  proration_behavior?: string;
  seats?: number;
  volumes?: {
    [k: string]: number;
  };
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "CreateSubscriptionRequest".
 */
export interface CreateSubscriptionRequest {
  payment_id?: string;
  plan: string;
  products?: {
    [k: string]: unknown;
  };
  promo_code?: string;
  seats?: number;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "CreditCard".
 */
export interface CreditCard {
  brand: CreditCardBrand;
  currency?: string;
  exp_month: number;
  exp_year: number;
  id: string;
  is_default?: boolean;
  last4: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "DesktopMetadata".
 */
export interface DesktopMetadata {
  executables: PlatformExecutables;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "PlatformExecutables".
 */
export interface PlatformExecutables {
  linux: PrebuiltBinaryMetadata;
  mac: PrebuiltBinaryMetadata;
  windows: PrebuiltBinaryMetadata;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "Distribution".
 */
export interface Distribution {
  description?: string;
  name: string;
  summary?: string;
  version?: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "EmailSession".
 */
export interface EmailSession {
  id: string;
  name: string;
  sent?: string[];
}
/**
 * Orderable only if the customer has never trialed this plan's emulator, nor has an active paid
 * subscription for it.
 *
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "EmulatorOnceOrderablePlan".
 */
export interface EmulatorOnceOrderablePlan {
  currency: string;
  discount?: Discount;
  emulator: EmulatorType;
  family: PlanFamily;
  id: string;
  interval_months: number;
  max_duration?: {
    [k: string]: number;
  };
  multi_interval_plan_family?: boolean;
  name: string;
  plan_seat_limit?: number;
  prepaid?: boolean;
  products: Product[];
  provider: SubscriptionProvider;
  public?: boolean;
  subscribable?: boolean;
  supersedes_plan_ids?: string[];
  switchable?: boolean;
  taxable?: string[];
  updatable?: boolean;
  visible?: boolean;
}
/**
 * Represents an ephemeral instance, which is a LocalStack instance accessible under a specific
 * endpoint URL.
 * There are several use cases for eph. instances, including:
 *   (1) quickly spinning up a LS instance if it cannot be run on the local machine
 *   (2) allow the user to browse the state of a cloud pod from the UI
 *   (3) creating preview environments for application builds
 *
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "EphemeralInstance".
 */
export interface EphemeralInstance {
  creation_time: number;
  endpoint_url: string;
  expiry_time: number;
  id: string;
  image: ComputeInstanceImage;
  instance_name: string;
  labels?: {
    [k: string]: string;
  };
  requestor: string;
  shape: ComputeInstanceShape;
  status: EphemeralInstanceStatus;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "EphemeralInstanceConfig".
 */
export interface EphemeralInstanceConfig {
  allow_workspace_access?: boolean;
  env_vars?: {
    [k: string]: string;
  };
  image?: ComputeInstanceImage;
  instance_name: string;
  labels?: {
    [k: string]: string;
  };
  lifetime?: number;
  pod_on_shutdown?: boolean;
  requestor: string;
  shape?: ComputeInstanceShape;
  shutdown_timeout?: number;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "ExchangeAzureMarketplaceTokenRequest".
 */
export interface ExchangeAzureMarketplaceTokenRequest {
  token: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "Extension".
 */
export interface Extension {
  author?: string;
  created?: number;
  description?: string;
  display_name?: string;
  distribution?: Distribution;
  has_ui?: boolean;
  id: string;
  logo?: string;
  name: string;
  official?: boolean;
  org_id?: string;
  plugin_name: string;
  published?: boolean;
  submission_state?: ExtensionSubmissionState;
  tier?: PlanFamily;
  version?: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "FeatureControlRecord".
 */
export interface FeatureControlRecord {
  feature_mappings?: {
    [k: string]: FeatureMapping;
  };
  feature_overrides?: FeatureOverrides;
  id: string;
  org_id: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "FeatureMapping".
 */
export interface FeatureMapping {
  plan_id: string;
  product_ids?: string[];
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "FeatureOverrides".
 */
export interface FeatureOverrides {
  add?: {
    [k: string]: unknown[];
  };
  remove?: {
    [k: string]: unknown[];
  };
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "FeatureSettings".
 */
export interface FeatureSettings {
  ci_projects?: boolean;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "Feedback".
 */
export interface Feedback {
  additionalText?: string;
  feat_chaos?: number;
  feat_collab?: number;
  feat_insights?: number;
  id: string;
  motive_costs?: boolean;
  motive_local?: boolean;
  motive_regulated?: boolean;
  seniority?: string;
  showSurvey?: boolean;
  subscription_id?: string;
  survey_id?: string;
  time: number;
  user_id: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "FinishSignupRequest".
 */
export interface FinishSignupRequest {
  company?: string;
  firstname: string;
  job_title?: string;
  lastname: string;
  legal_acceptance_context?: string;
  newsletter: boolean;
  signup_survey: SignupSurveyRequest;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "SignupSurveyRequest".
 */
export interface SignupSurveyRequest {
  emulator: EmulatorType;
  is_student?: boolean;
  planned_usage_type?: PlannedUsageType;
  promo_code?: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "GetInvitationResponse".
 */
export interface GetInvitationResponse {
  created: number;
  email: string;
  expire_at: number;
  id: string;
  join_settings?: UserInvitationDetails;
  name: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "GetOrganizationResponse".
 */
export interface GetOrganizationResponse {
  basic_details: OrganizationBasicDetails;
  billing_details: OrganizationBillingDetails;
  id: string;
  pods_settings?: CloudPodsSettings;
  scim_settings?: {
    [k: string]: OrganizationSCIMSettings;
  };
  sso_settings?: {
    [k: string]: OrganizationSSOSettings;
  };
  tax_details: OrganizationTaxDetails;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "GetOrganizationStatsResponse".
 */
export interface GetOrganizationStatsResponse {
  num_admin_members: number;
  num_all_members: number;
  num_invitations: number;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "HubspotContactMembershipStatus".
 */
export interface HubspotContactMembershipStatus {
  hubspot_contact_id: string;
  roles: UserRole[];
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "HubspotToken".
 */
export interface HubspotToken {
  token: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "IdentifiableModel".
 */
export interface IdentifiableModel {
  id: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "IdentityLogEvent".
 */
export interface IdentityLogEvent {
  created_at?: string;
  expire_at?: number;
  extras?: {
    [k: string]: unknown;
  };
  gsi_pk?: string;
  id?: string;
  idp_name?: string;
  message: string;
  org_id: string;
  scope: IdentityEventScope;
  success: boolean;
  user_email?: string;
  user_id?: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "IdentityProvider".
 */
export interface IdentityProvider {
  IDPSignout?: boolean;
  MetadataFile?: string;
  MetadataURL?: string;
  attribute_mapping?: {
    [k: string]: string;
  };
  attributes_request_method?: string;
  attributes_url?: string;
  authorize_scopes?: string;
  authorize_url?: string;
  client_id?: string;
  client_secret?: string;
  idp_name: string;
  jwks_uri?: string;
  oidc_issuer?: string;
  org_id: string;
  provider_type: string;
  token_url?: string;
}
/**
 * Discount that can be only applied once per organization
 *
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "IntroductoryDiscount".
 */
export interface IntroductoryDiscount {
  clear_on_cancel?: boolean;
  discount_flat?: number;
  discount_percentage?: number;
  discount_products?: string[];
  duration_months?: number;
  id: string;
  name?: string;
  valid_until?: number;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "InvitationCoordinationIdp".
 */
export interface InvitationCoordinationIdp {
  name: string;
  signup_portal_url: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "InvitationCoordinationResult".
 */
export interface InvitationCoordinationResult {
  account_state: InvitationCoordinationAccountState;
  all_idps: InvitationCoordinationIdp[];
  eligibility_state: InvitationEligibilityState;
  org_name: string;
  strict_sso_idps: InvitationCoordinationIdp[];
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "Invoice".
 */
export interface Invoice {
  created: number;
  currency: string;
  hosted_invoice_url?: string;
  invoice_pdf?: string;
  number?: string;
  quantity?: number;
  status: InvoiceStatus;
  status_transitions?: InvoiceStatusTransitions;
  subscription?: string;
  total: number;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "InvoiceStatusTransitions".
 */
export interface InvoiceStatusTransitions {
  finalized_at?: number;
  marked_uncollectible_at?: number;
  paid_at?: number;
  voided_at?: number;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "LegalAcceptance".
 */
export interface LegalAcceptance {
  client_ip?: string;
  context?: string;
  document_type: DocumentType;
  id: string;
  org_id: string;
  org_name: string;
  source: LegalAcceptanceSource;
  timestamp?: number;
  user_agent: string;
  user_email: string;
  user_id: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "LegalAcceptanceRequest".
 */
export interface LegalAcceptanceRequest {
  context?: string;
  document_type: DocumentType;
  source: LegalAcceptanceSource;
}
/**
 * Common license attributes
 *
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "License".
 */
export interface License {
  id: string;
  license_format: string;
  signature?: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "LicenseAssignment".
 */
export interface LicenseAssignment {
  emulator?: EmulatorType;
  excluded_licensing_products?: ProductInfo[];
  id?: string;
  included_licensing_products?: ProductInfo[];
  org_id: string;
  subscription_ids?: string[];
  user_id?: string;
}
/**
 * A description of the product being licensed. Does not necessarily map to the stripe products.
 *
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "ProductInfo".
 */
export interface ProductInfo {
  metadata?: {
    [k: string]: unknown;
  };
  name: string;
  version: string;
  version_operator?: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "LicenseAssignmentInfo".
 */
export interface LicenseAssignmentInfo {
  emulator: EmulatorType;
  is_sub_active: boolean;
  plan_family: PlanFamily;
  subscription_id: string;
  subscription_name: string;
}
/**
 * The Catalog containing which features are available in the latest version of LocalStack and in which plan.
 *
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "LicenseCatalogV1".
 */
export interface LicenseCatalogV1 {
  cloudformation_resources?: {
    [k: string]: {
      [k: string]: CloudFormationCatalogEntry;
    };
  };
  localstack?: {
    [k: string]: string;
  };
  meta?: {
    [k: string]: string;
  };
  schema_version?: string;
  services?: {
    [k: string]: {
      [k: string]: ServiceCatalogEntry;
    };
  };
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "ServiceCatalogEntry".
 */
export interface ServiceCatalogEntry {
  operations: string[];
  plans?: string[];
  provider: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "LicenseV1".
 */
export interface LicenseV1 {
  credentials: string;
  expiry_date: string;
  id: string;
  issue_date: string;
  last_activated?: string;
  license_format?: string;
  license_secret?: string;
  license_status?: LicenseStatus;
  license_type: string;
  org_id: string;
  products?: ProductInfo[];
  reactivate_after?: string;
  signature?: string;
  user_id?: string;
}
/**
 * This is the auth token we give the user or machine to authenticate themselves. Auth tokens are a form of
 * licensing credentials that allow requesting and activating of licenses. Each set of credentials are valid
 * for one entity (e.g., user) in one organization. An entity can only ever have one active set of
 * credentials.
 *
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "LicensingAuthToken".
 */
export interface LicensingAuthToken {
  active: boolean;
  created?: number;
  created_at: number;
  entity_id: string;
  entity_type: string;
  id: string;
  name?: string;
  org_id: string;
  rotated_from?: string;
  token: string;
  token_type?: LicensingTokenType;
  user_id: string;
}
/**
 * This is the object we give back to legacy LS versions
 *
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "LicensingDecryptionKey".
 */
export interface LicensingDecryptionKey {
  key: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "LicensingToken".
 */
export interface LicensingToken {
  token: string;
  type: LicensingTokenType;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "LogLine".
 */
export interface LogLine {
  content: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "MembershipActionCapability".
 */
export interface MembershipActionCapability {
  allowed: boolean;
  blocked_reason?: MembershipActionBlockedReason;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "MembershipCapabilities".
 */
export interface MembershipCapabilities {
  change_role: MembershipActionCapability;
  edit_permissions: MembershipActionCapability;
  remove: MembershipActionCapability;
}
/**
 * Discount that applies only when no paid subscriptions exist.
 *
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "NonPayingCustomerIntroductoryDiscount".
 */
export interface NonPayingCustomerIntroductoryDiscount {
  clear_on_cancel?: boolean;
  discount_flat?: number;
  discount_percentage?: number;
  discount_products?: string[];
  duration_months?: number;
  id: string;
  name?: string;
  valid_until?: number;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "Notification".
 */
export interface Notification {
  created?: number;
  email: string;
  id: string;
  plan_text?: string;
  read?: boolean;
  reference_id?: string;
  rich_text?: string;
  subject: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "OrderContext".
 */
export interface OrderContext {
  acquisition_channel?: AcquisitionChannel;
  backdate_start_date?: number;
  billing_channel?: BillingChannel;
  billing_cycle_anchor?: number | string;
  country?: string;
  custom_renewal_date?: number;
  customer_id?: string;
  hubspot_subscription_id?: string;
  ineligible_trial_emulators?: EmulatorType[];
  interval?: number;
  is_non_paying_customer?: boolean;
  mrr?: number;
  mrr_private?: number;
  name?: string;
  new_customer?: boolean;
  org_id: string;
  origin?: string;
  payment_id?: string;
  promo_code?: string;
  proration_behavior?: string;
  seats: number;
  volumes?: {
    [k: string]: number;
  };
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "Organization".
 */
export interface Organization {
  address?: string;
  aws_customer?: string;
  city?: string;
  cloud_pods_stats?: CloudPodsStats;
  country?: string;
  creator?: string;
  deleted?: boolean | number;
  email?: string;
  has_custom_terms?: boolean;
  hubspot_company_id?: string;
  id: string;
  name: string;
  orgType?: OrganizationType;
  phone?: string;
  settings?: OrganizationSettings;
  state?: string;
  stripe_customer?: {
    [k: string]: string;
  };
  stripe_tax?:
    | string
    | {
        [k: string]: unknown;
      };
  subscriptions?: string[];
  tax_id?: string;
  tax_id_type?: TaxIdType;
  tenant_id?: string;
  zip?: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "OrganizationSettings".
 */
export interface OrganizationSettings {
  cloud_pods?: CloudPodsSettings;
  features?: FeatureSettings;
  scim_settings?: {
    [k: string]: OrganizationSCIMSettings;
  };
  sso_settings?: {
    [k: string]: OrganizationSSOSettings;
  };
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "PatchCloudPodsSettings".
 */
export interface PatchCloudPodsSettings {
  auto_cleanup_max_pod_versions?: number;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "PatchOrganizationRequest".
 */
export interface PatchOrganizationRequest {
  basic_details?: OrganizationBasicDetails;
  billing_details?: OrganizationBillingDetails;
  tax_details?: OrganizationTaxDetails;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "PatchOrganizationResponse".
 */
export interface PatchOrganizationResponse {
  basic_details: OrganizationBasicDetails;
  billing_details: OrganizationBillingDetails;
  id: string;
  tax_details: OrganizationTaxDetails;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "PatchOrganizationSettingsRequest".
 */
export interface PatchOrganizationSettingsRequest {
  pods_settings?: PatchCloudPodsSettings;
  scim_settings?: {
    [k: string]: PatchSCIMSettings;
  };
  sso_settings?: {
    [k: string]: PatchSSOSettings;
  };
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "PatchSCIMSettings".
 */
export interface PatchSCIMSettings {
  is_enabled?: boolean;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "PatchSSOSettings".
 */
export interface PatchSSOSettings {
  assign_license_on_join?: boolean;
  default_membership_permissions?: string[];
  default_membership_role?: string;
  strict_sso_mode?: boolean;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "PatchOrganizationSettingsResponse".
 */
export interface PatchOrganizationSettingsResponse {
  id: string;
  pods_settings: CloudPodsSettings;
  scim_settings: {
    [k: string]: OrganizationSCIMSettings;
  };
  sso_settings: {
    [k: string]: OrganizationSSOSettings;
  };
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "PodsStorageSettings".
 */
export interface PodsStorageSettings {
  allowed_origins?: string[];
  hostname_external?: string;
  s3_notification_handler?: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "RbacAccessControlStatement".
 */
export interface RbacAccessControlStatement {
  cache_response_ttl?: number;
  endpoint: string;
  features?: RbacGroupingStatement;
  methods?: string[];
  roles: RbacGroupingStatement;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "RbacGroupingStatement".
 */
export interface RbacGroupingStatement {
  children: (unknown | RbacGroupingStatement)[];
  variant?: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "RecaptchaResponse".
 */
export interface RecaptchaResponse {
  score?: number;
  success: boolean;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "ResendInvitationResponse".
 */
export interface ResendInvitationResponse {
  created: number;
  email: string;
  expire_at: number;
  id: string;
  join_settings?: UserInvitationDetails;
  name: string;
}
/**
 * Used for fully authenticated users
 *
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "ResolvedUserClaims".
 */
export interface ResolvedUserClaims {
  org_id: string;
  user_id: string;
  username: string;
}
/**
 * SCIM-specific state attached to a ``UserMembership``, kept separate from
 * the membership details so the user<>org relationship stays agnostic of how
 * it is provisioned (mirrors how ``OrganizationSCIMSettings`` isolates
 * SCIM-related org settings).
 *
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "ScimMembershipProfile".
 */
export interface ScimMembershipProfile {
  role_group?: string;
}
/**
 * A snapshot row describing the activity of a seat holder for a given subscription and product type
 * (emulator). Grain is (org_id, user_id, subscription_id, emulator). Objects coming from
 * api.tinybird.co/v0/pipes/seat_holder_activity__v0.json.
 *
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "SeatHolderActivity".
 */
export interface SeatHolderActivity {
  email: string;
  full_name: string;
  has_activation_attempt_ever: boolean;
  has_activation_ever: boolean;
  has_activation_in_period: boolean;
  is_active_in_period: boolean;
  last_activation_date: string;
  last_active_date: string;
  org_id: string;
  role?: UserRole;
  total_rows: number;
  user_id: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "SelfAssignLicenseRequest".
 */
export interface SelfAssignLicenseRequest {
  subscription_id: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "SelfAssignmentPreflight".
 */
export interface SelfAssignmentPreflight {
  options?: AssignableSubscriptionOption[];
  permitted?: boolean;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "Session".
 */
export interface Session {
  token: string;
  user_id: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "SetLicenseAssignmentsRequest".
 */
export interface SetLicenseAssignmentsRequest {
  subscription_ids: string[];
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "SignInRequest".
 */
export interface SignInRequest {
  password: string;
  recaptcha_token?: string;
  username: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "SignupRequest".
 */
export interface SignupRequest {
  email: string;
  password: string;
  recaptcha_token: string;
  signup_survey: SignupSurveyRequest;
}
/**
 * An object describing an AWS API call made against localstack. Objects coming from
 * api.tinybird.co/v0/pipes/dashboard_stack_aws_requests__v0.json.
 *
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "StackAwsApiCall".
 */
export interface StackAwsApiCall {
  account_id: string;
  api_key: string;
  client_time: string;
  count: number;
  err_msg?: string;
  err_type?: string;
  is_internal: boolean;
  machine_id: string;
  operation: string;
  region: string;
  server_time: string;
  service: string;
  session_id: string;
  status_code: number;
  user_agent: string;
}
/**
 * An object describing properties and statistics of a stack (a localstack run). Objects coming from
 * api.tinybird.co/v0/pipes/dashboard_stacks_overview__v0.json.
 *
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "StackInfo".
 */
export interface StackInfo {
  api_key: string;
  api_key_name?: string;
  duration_in_seconds?: number;
  is_ci: boolean;
  is_docker: boolean;
  number_of_api_calls_error?: number;
  number_of_api_calls_success?: number;
  number_of_services?: number;
  server_time_utc: string;
  session_id: string;
  system: string;
  top_user_agent?: string;
  user_email?: string;
  user_id?: string;
  user_name?: string;
  version: string;
}
/**
 * An object describing how often a particular service operation was called. Objects coming from
 * api.tinybird.co/v0/pipes/stack_insights_service_usage__v0.json.
 *
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "StackServiceUsage".
 */
export interface StackServiceUsage {
  number_of_api_calls: number;
  operation: string;
  service: string;
  session_id: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "Subscription".
 */
export interface Subscription {
  acquisition_channel?: AcquisitionChannel;
  billing_channel?: BillingChannel;
  cancel_at?: number;
  cancel_at_period_end?: boolean;
  cancellation_details?: CancellationDetails;
  created: number;
  currency: string;
  current_period_end: number;
  current_period_start: number;
  custom_renewal_date?: number;
  customer_id: string;
  discount?: Discount;
  discount_reaches_renewal: boolean;
  estimated_mrr?: number;
  estimated_private_mrr?: number;
  hubspot_subscription_id?: string;
  id: string;
  interval_months: number;
  name: string;
  org_id: string;
  payment_id?: string;
  plan: Plan | EmulatorOnceOrderablePlan;
  products: Product[];
  seats: number;
  start_date: number;
  status: SubscriptionStatus;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "SubscriptionCIAuthToken".
 */
export interface SubscriptionCIAuthToken {
  deleted_tokens_usage: number;
  emulator: EmulatorType;
  plan_family: PlanFamily;
  quota: number;
  subscription_display_name: string;
  subscription_id: string;
  tokens: CIAuthTokenUsage[];
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "TaxDetails".
 */
export interface TaxDetails {
  tax_amount: number;
  tax_rate: number;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "UpdateAccountRequest".
 */
export interface UpdateAccountRequest {
  company?: string;
  firstname?: string;
  github_username?: string;
  job_title?: string;
  lastname?: string;
  newsletter?: boolean;
  newsletter_disabled?: boolean;
  phone?: string;
  signup_survey?: SignupSurvey;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "UpdateMembershipRequest".
 */
export interface UpdateMembershipRequest {
  auto_assign_license?: boolean;
  permissions?: string[];
  role?: UserRole;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "UpdateSubscriptionRequest".
 */
export interface UpdateSubscriptionRequest {
  payment_id?: string;
  plan?: string;
  promo_code?: string;
  seats?: number;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "UsageRecord".
 */
export interface UsageRecord {
  id: string;
  org_id: string;
  usage_details?: {
    [k: string]: UsageRecordDetails;
  };
  usage_refills?: UsageRecordRefillPackage[];
  usage_total?: number;
}
/**
 * Note refill packages are currently global!
 *
 * Which means we cannot refill a particular subscription - the customer receives a "global" refill
 * applied to all available usage records within the specified period.
 *
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "UsageRecordRefillPackage".
 */
export interface UsageRecordRefillPackage {
  refill_end?: number;
  refill_start: number;
  refill_usage: number;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "UsageSummary".
 */
export interface UsageSummary {
  ci_keys_usage_by_date?: {
    [k: string]: UsageRecordDetails;
  };
  usage_by_product: {
    [k: string]: number;
  };
  usage_by_type: {
    [k: string]: number;
  };
  usage_period_end: number;
  usage_period_start: number;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "UserInvitation".
 */
export interface UserInvitation {
  created?: number;
  email: string;
  expire_at?: number;
  id: string;
  invitation_token: string;
  join_settings?: UserInvitationDetails;
  name: string;
  org_id: string;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "UserMembershipDetails".
 */
export interface UserMembershipDetails {
  auto_assign_license: boolean;
  permissions: string[];
  role: UserRole;
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "UserMembershipView".
 */
export interface UserMembershipView {
  capabilities?: MembershipCapabilities;
  created: number;
  id: string;
  is_admin?: boolean;
  is_creator?: boolean;
  is_primary?: boolean;
  is_scim_provisioned?: boolean;
  membership_details: UserMembershipDetails;
  org_id: string;
  org_name: string;
  scim_details?: ScimMembershipProfile;
  user_email: string;
  user_full_name: string;
  user_id: string;
}

/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AWSSubscriptionAction".
 */
export const enum AWSSubscriptionAction {
  ENTITLEMENT_UPDATED = 'entitlement-updated',
  SUBSCRIBE_SUCCESS = 'subscribe-success',
  SUBSCRIBE_FAIL = 'subscribe-fail',
  UNSUBSCRIBE_PENDING = 'unsubscribe-pending',
  UNSUBSCRIBE_SUCCESS = 'unsubscribe-success',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "LicensingTokenType".
 */
export const enum LicensingTokenType {
  LICENSING_AUTH_TOKEN = 'licensing-auth-token',
  CI_SERVICE_AUTH_TOKEN = 'ci-service-auth-token',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AcquisitionChannel".
 */
export const enum AcquisitionChannel {
  SELF_SERVE = 'Self-serve',
  SALES = 'Sales',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "UserRole".
 */
export const enum UserRole {
  ADMIN = 'admin',
  MEMBER = 'member',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "UserSource".
 */
export const enum UserSource {
  GOOGLE = 'google',
  MICROSOFT = 'microsoft',
  GITHUB = 'github',
  FRIEND = 'friend',
  TWITTER = 'twitter',
  ADS = 'ads',
  FORUM = 'forum',
  BLOG = 'blog',
  OTHER = 'other',
  NOT_SET = 'not_set',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "OrganizationType".
 */
export const enum OrganizationType {
  COMPANY = 'comp',
  INDIVIDUAL = 'ind',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "TaxIdType".
 */
export const enum TaxIdType {
  AU_ABN = 'au_abn',
  AU_ARN = 'au_arn',
  EU_VAT = 'eu_vat',
  BR_CNPJ = 'br_cnpj',
  BR_CPF = 'br_cpf',
  CA_BN = 'ca_bn',
  CA_GST_HST = 'ca_gst_hst',
  CA_PST_BC = 'ca_pst_bc',
  CA_PST_MB = 'ca_pst_mb',
  CA_PST_SK = 'ca_pst_sk',
  CA_QST = 'ca_qst',
  CL_TIN = 'cl_tin',
  HK_BR = 'hk_br',
  IN_GST = 'in_gst',
  ID_NPWP = 'id_npwp',
  IL_VAT = 'il_vat',
  JP_CN = 'jp_cn',
  JP_RN = 'jp_rn',
  KR_BRN = 'kr_brn',
  LI_UID = 'li_uid',
  MY_FRP = 'my_frp',
  MY_ITN = 'my_itn',
  MY_SST = 'my_sst',
  MX_RFC = 'mx_rfc',
  NZ_GST = 'nz_gst',
  NO_VAT = 'no_vat',
  RU_INN = 'ru_inn',
  RU_KPP = 'ru_kpp',
  SA_VAT = 'sa_vat',
  SG_GST = 'sg_gst',
  SG_UEN = 'sg_uen',
  ZA_VAT = 'za_vat',
  ES_CIF = 'es_cif',
  CH_VAT = 'ch_vat',
  TW_VAT = 'tw_vat',
  TH_VAT = 'th_vat',
  AE_TRN = 'ae_trn',
  GB_VAT = 'gb_vat',
  US_EIN = 'us_ein',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AdminPermission".
 */
export const enum AdminPermission {
  USERS_READ = 'admin:users:read',
  USERS_WRITE = 'admin:users:write',
  WORKSPACES_READ = 'admin:workspaces:read',
  WORKSPACES_WRITE = 'admin:workspaces:write',
  EXTENSIONS_READ = 'admin:extensions:read',
  EXTENSIONS_WRITE = 'admin:extensions:write',
  FEATURE_FLAGS_READ = 'admin:feature_flags:read',
  FEATURE_FLAGS_WRITE = 'admin:feature_flags:write',
  ANNOUNCEMENTS = 'admin:announcements',
  SUPER_ADMIN = 'admin:*',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "EmulatorType".
 */
export const enum EmulatorType {
  AWS = 'aws',
  SNOWFLAKE = 'snowflake',
  AZURE = 'azure',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "PlanFamily".
 */
export const enum PlanFamily {
  HOBBY_PLANS = 'hobby',
  PRO_PLANS = 'pro',
  TEAM_PLANS = 'team',
  LEGACY_PLANS = 'legacy',
  ENTERPRISE_PLANS = 'enterprise',
  PREVIEW_PLANS = 'preview',
  TRIAL_PLANS = 'trial',
  FREEMIUM_PLANS = 'freemium',
  BASE_PLANS = 'base',
  ULTIMATE_PLANS = 'ultimate',
  STUDENT = 'student',
  COMMUNITY = 'community',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AuditTrailInitiatorType".
 */
export const enum AuditTrailInitiatorType {
  USER = 'user',
  SYSTEM = 'system',
  PLATFORM_ADMIN = 'platform_admin',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AuditTrailQueryStatus".
 */
export const enum AuditTrailQueryStatus {
  SCHEDULED = 'Scheduled',
  RUNNING = 'Running',
  COMPLETE = 'Complete',
  FAILED = 'Failed',
  CANCELLED = 'Cancelled',
  TIMEOUT = 'Timeout',
  UNKNOWN = 'Unknown',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AuthLinkType".
 */
export const enum AuthLinkType {
  PUBLIC_SSO = 'public_sso',
  CUSTOM_SSO = 'custom_sso',
  SIGNUP = 'signup',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "SubscriptionProvider".
 */
export const enum SubscriptionProvider {
  STRIPE = 'stripe',
  PLATFORM = 'platform',
  UNKNOWN = 'unknown',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "ProductTaxCode".
 */
export const enum ProductTaxCode {
  SAAS_DOWNLOAD_B2B = 'txcd_10103101',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "ProductType".
 */
export const enum ProductType {
  SEATS = 'seats',
  CI_USAGE = 'ci_usage',
  POD_USAGE = 'pod_usage',
  COMPUTE_USAGE = 'compute_usage',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "AwsMarketplaceSubscriptionEventStatus".
 */
export const enum AwsMarketplaceSubscriptionEventStatus {
  PROCESSED = 'processed',
  UNPROCESSED = 'unprocessed',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "BillingChannel".
 */
export const enum BillingChannel {
  AWS_MARKETPLACE = 'AWS Marketplace',
  AZURE_MARKETPLACE = 'Azure Marketplace',
  NONE = 'None',
  STRIPE = 'Stripe',
  INVOICE = 'Invoice',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "SupportedImage".
 */
export const enum SupportedImage {
  localstack = 'localstack/localstack-pro',
  snowflake = 'localstack/snowflake',
  azure = 'localstack/localstack-azure-alpha',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "EphemeralInstanceStatus".
 */
export const enum EphemeralInstanceStatus {
  CREATING = 'creating',
  RUNNING = 'running',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "RevokingReason".
 */
export const enum RevokingReason {
  DELETED = 'deleted',
  ROTATED = 'rotated',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "CancellationFeedback".
 */
export const enum CancellationFeedback {
  TOO_EXPENSIVE = 'too_expensive',
  MISSING_FEATURES = 'missing_features',
  SWITCHED_SERVICE = 'switched_service',
  UNUSED = 'unused',
  CUSTOMER_SERVICE = 'customer_service',
  TOO_COMPLEX = 'too_complex',
  LOW_QUALITY = 'low_quality',
  OTHER = 'other',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "CloudPodContentMode".
 */
export const enum CloudPodContentMode {
  PUSH = 'push',
  PULL = 'pull',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "CognitoIdentityStatus".
 */
export const enum CognitoIdentityStatus {
  UNCONFIRMED = 'UNCONFIRMED',
  CONFIRMED = 'CONFIRMED',
  EXTERNAL_PROVIDER = 'EXTERNAL_PROVIDER',
  UNKNOWN = 'UNKNOWN',
  RESET_REQUIRED = 'RESET_REQUIRED',
  FORCE_CHANGE_PASSWORD = 'FORCE_CHANGE_PASSWORD',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "UserOrigin".
 */
export const enum UserOrigin {
  SIGNUP = 'signup',
  INVITE = 'invite',
  PUBLIC_SSO = 'public_sso',
  CUSTOM_SSO = 'custom_sso',
  ADMIN_PANEL = 'admin_panel',
  SCIM = 'scim',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "PlannedUsageType".
 */
export const enum PlannedUsageType {
  PROFESSIONAL = 'professional',
  HOBBYIST = 'hobbyist',
  FREEMIUM = 'freemium',
  MARKETPLACE = 'marketplace',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "CreditCardBrand".
 */
export const enum CreditCardBrand {
  AMERICAN_EXPRESS = 'American Express',
  DINERS_CLUB = 'Diners Club',
  DISCOVER = 'Discover',
  JSB = 'JCB',
  MASTERCARD = 'MasterCard',
  UNION_PAY = 'UnionPay',
  VISA = 'Visa',
  UNKNOWN = 'Unknown',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "DataStorageTable".
 */
export const enum DataStorageTable {
  ENTITIES = 'entities_table',
  CACHE = 'cache_table',
  LOGS = 'logs_table',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "DocumentType".
 */
export const enum DocumentType {
  TOS = 'tos',
  MSA = 'msa',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "EventMonitoringExecutionState".
 */
export const enum EventMonitoringExecutionState {
  SUCCESS = 'success',
  FAILED = 'failed',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "EventMonitoringTrigger".
 */
export const enum EventMonitoringTrigger {
  SQS_EVENT_PROCESSING_STARTED = 'sqs_event_processing_started',
  SQS_EVENT_PROCESSING_FAILED = 'sqs_event_processing_failed',
  SQS_EVENT_PROCESSING_FINISHED = 'sqs_event_processing_finished',
  EVENT_HANDLING_STARTED = 'event_handling_started',
  EVENT_HANDLING_FAILED = 'event_handling_failed',
  EVENT_HANDLING_FINISHED = 'event_handling_finished',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "ExtensionSubmissionState".
 */
export const enum ExtensionSubmissionState {
  SUBMITTED = 'submitted',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  PUBLISHED = 'published',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "FlaskGKey".
 */
export const enum FlaskGKey {
  RBAC_HANDLED = 'rbac_handled',
  RBAC_MATCH = 'rbac_match',
  RESPONSE_CACHE_KEY = 'response_cache_key',
  RESPONSE_CACHE_TTL = 'response_cache_ttl',
  AUTH_USER = 'auth_user',
  USER = 'user',
  ORG = 'org',
  FEATURES = 'features',
  IMPERSONATOR_USER_ID = 'impersonator_user_id',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "HubSpotEmails".
 */
export const enum HubSpotEmails {
  TRIAL_ENDING_TOMORROW_AWS = 'hubspot.email_trial_ending_tomorrow_id_aws',
  TRIAL_ENDING_TOMORROW_SNOWFLAKE = 'hubspot.email_trial_ending_tomorrow_id_snowflake',
  WELCOME_FREEMIUM = 'hubspot.email_welcome_id_freemium',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "HubSpotSubscriptionAttributeChange".
 */
export const enum HubSpotSubscriptionAttributeChange {
  FEATURES = 'features',
  LICENSES_ASSIGNED = 'licenses_assigned',
  CUSTOM_TERMS = 'custom_terms',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "IdentityEventScope".
 */
export const enum IdentityEventScope {
  SSO = 'sso',
  SCIM = 'scim',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "IdentityType".
 */
export const enum IdentityType {
  PUBLIC_SSO = 'public_sso',
  CUSTOM_SSO = 'custom_sso',
  SIGNUP = 'signup',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "InvitationCoordinationAccountState".
 */
export const enum InvitationCoordinationAccountState {
  NEW_ACCOUNT = 'NEW_ACCOUNT',
  EXISTING_ACCOUNT = 'EXISTING_ACCOUNT',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "InvitationEligibilityState".
 */
export const enum InvitationEligibilityState {
  INELIGIBLE_FREEMIUM_WORKSPACE = 'INELIGIBLE_FREEMIUM_WORKSPACE',
  ELIGIBLE = 'ELIGIBLE',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "InvoiceStatus".
 */
export const enum InvoiceStatus {
  DRAFT = 'draft',
  OPEN = 'open',
  PAID = 'paid',
  UNCOLLECTIBLE = 'uncollectible',
  VOID = 'void',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "LegalAcceptanceSource".
 */
export const enum LegalAcceptanceSource {
  CHECKOUT = 'checkout',
  SIGN_UP = 'sign-up',
  MEMBERSHIP_CONFIRMATION = 'membership-confirmation',
  OVERLAY_PROMPT = 'overlay-prompt',
  TOS_PAGE = 'tos-page',
  STUDENT_VERIFICATION = 'student-verification',
  TRIAL_EXPIRED = 'trial-expired-page',
  PRICING_PLANS = 'pricing-plans',
  GETTING_STARTED = 'getting-started',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "LicenseStatus".
 */
export const enum LicenseStatus {
  UNKNOWN = 'UNKNOWN',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  EXPIRED = 'EXPIRED',
  SUSPENDED = 'SUSPENDED',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "LocalStackAppinspectorFeature".
 */
export const enum LocalStackAppinspectorFeature {
  LOCALSTACK_APPINSPECTOR_SPAN_COUNT_LIMIT = 'span_count_limit',
  LOCALSTACK_APPINSPECTOR_VIEW_IAM_POLICY_ERRORS = 'view_iam_policy_errors',
  LOCALSTACK_APPINSPECTOR_VIEW_RESPONSE_PAYLOADS = 'view_response_payloads',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "LocalstackAwsProvider".
 */
export const enum LocalstackAwsProvider {
  LOCALSTACK_AWS_PROVIDER_ACM_DEFAULT = 'acm:default',
  LOCALSTACK_AWS_PROVIDER_APIGATEWAY_DEFAULT = 'apigateway:default',
  LOCALSTACK_AWS_PROVIDER_APIGATEWAY_LEGACY = 'apigateway:legacy',
  LOCALSTACK_AWS_PROVIDER_APIGATEWAY_NEXT_GEN = 'apigateway:next_gen',
  LOCALSTACK_AWS_PROVIDER_CLOUDFORMATION_DEFAULT = 'cloudformation:default',
  LOCALSTACK_AWS_PROVIDER_CLOUDFORMATION_ENGINE_LEGACY = 'cloudformation:engine-legacy',
  LOCALSTACK_AWS_PROVIDER_CLOUDFORMATION_ENGINE_V2 = 'cloudformation:engine-v2',
  LOCALSTACK_AWS_PROVIDER_CLOUDWATCH_DEFAULT = 'cloudwatch:default',
  LOCALSTACK_AWS_PROVIDER_CLOUDWATCH_V1 = 'cloudwatch:v1',
  LOCALSTACK_AWS_PROVIDER_CLOUDWATCH_V2 = 'cloudwatch:v2',
  LOCALSTACK_AWS_PROVIDER_CLOUDWATCH_PRO = 'cloudwatch:pro',
  LOCALSTACK_AWS_PROVIDER_CONFIG_DEFAULT = 'config:default',
  LOCALSTACK_AWS_PROVIDER_DYNAMODB_DEFAULT = 'dynamodb:default',
  LOCALSTACK_AWS_PROVIDER_DYNAMODB_V2 = 'dynamodb:v2',
  LOCALSTACK_AWS_PROVIDER_DYNAMODBSTREAMS_DEFAULT = 'dynamodbstreams:default',
  LOCALSTACK_AWS_PROVIDER_DYNAMODBSTREAMS_V2 = 'dynamodbstreams:v2',
  LOCALSTACK_AWS_PROVIDER_EC2_DEFAULT = 'ec2:default',
  LOCALSTACK_AWS_PROVIDER_ES_DEFAULT = 'es:default',
  LOCALSTACK_AWS_PROVIDER_EVENTS_DEFAULT = 'events:default',
  LOCALSTACK_AWS_PROVIDER_EVENTS_LEGACY = 'events:legacy',
  LOCALSTACK_AWS_PROVIDER_EVENTS_V1 = 'events:v1',
  LOCALSTACK_AWS_PROVIDER_EVENTS_V2 = 'events:v2',
  LOCALSTACK_AWS_PROVIDER_FIREHOSE_DEFAULT = 'firehose:default',
  LOCALSTACK_AWS_PROVIDER_IAM_DEFAULT = 'iam:default',
  LOCALSTACK_AWS_PROVIDER_KINESIS_DEFAULT = 'kinesis:default',
  LOCALSTACK_AWS_PROVIDER_KMS_DEFAULT = 'kms:default',
  LOCALSTACK_AWS_PROVIDER_LAMBDA_ASF = 'lambda:asf',
  LOCALSTACK_AWS_PROVIDER_LAMBDA_DEFAULT = 'lambda:default',
  LOCALSTACK_AWS_PROVIDER_LAMBDA_V2 = 'lambda:v2',
  LOCALSTACK_AWS_PROVIDER_LAMBDA_WEB_DEFAULT = 'lambda-web:default',
  LOCALSTACK_AWS_PROVIDER_LOGS_DEFAULT = 'logs:default',
  LOCALSTACK_AWS_PROVIDER_LOGS_V1 = 'logs:v1',
  LOCALSTACK_AWS_PROVIDER_LOGS_V2 = 'logs:v2',
  LOCALSTACK_AWS_PROVIDER_OPENSEARCH_DEFAULT = 'opensearch:default',
  LOCALSTACK_AWS_PROVIDER_REDSHIFT_DEFAULT = 'redshift:default',
  LOCALSTACK_AWS_PROVIDER_RESOURCE_GROUPS_DEFAULT = 'resource-groups:default',
  LOCALSTACK_AWS_PROVIDER_RESOURCEGROUPSTAGGINGAPI_DEFAULT = 'resourcegroupstaggingapi:default',
  LOCALSTACK_AWS_PROVIDER_RESOURCEGROUPSTAGGINGAPI_PRO = 'resourcegroupstaggingapi:pro',
  LOCALSTACK_AWS_PROVIDER_RESOURCEGROUPSTAGGINGAPI_LEGACY_PRO = 'resourcegroupstaggingapi:legacy_pro',
  LOCALSTACK_AWS_PROVIDER_ROUTE53_DEFAULT = 'route53:default',
  LOCALSTACK_AWS_PROVIDER_ROUTE53RESOLVER_DEFAULT = 'route53resolver:default',
  LOCALSTACK_AWS_PROVIDER_S3_DEFAULT = 's3:default',
  LOCALSTACK_AWS_PROVIDER_S3CONTROL_DEFAULT = 's3control:default',
  LOCALSTACK_AWS_PROVIDER_SCHEDULER_DEFAULT = 'scheduler:default',
  LOCALSTACK_AWS_PROVIDER_SECRETSMANAGER_DEFAULT = 'secretsmanager:default',
  LOCALSTACK_AWS_PROVIDER_SES_DEFAULT = 'ses:default',
  LOCALSTACK_AWS_PROVIDER_SNS_DEFAULT = 'sns:default',
  LOCALSTACK_AWS_PROVIDER_SNS_PRO = 'sns:pro',
  LOCALSTACK_AWS_PROVIDER_SQS_DEFAULT = 'sqs:default',
  LOCALSTACK_AWS_PROVIDER_SSM_DEFAULT = 'ssm:default',
  LOCALSTACK_AWS_PROVIDER_STEPFUNCTIONS_DEFAULT = 'stepfunctions:default',
  LOCALSTACK_AWS_PROVIDER_STEPFUNCTIONS_V2 = 'stepfunctions:v2',
  LOCALSTACK_AWS_PROVIDER_STS_DEFAULT = 'sts:default',
  LOCALSTACK_AWS_PROVIDER_SUPPORT_DEFAULT = 'support:default',
  LOCALSTACK_AWS_PROVIDER_SWF_DEFAULT = 'swf:default',
  LOCALSTACK_AWS_PROVIDER_TRANSCRIBE_DEFAULT = 'transcribe:default',
  LOCALSTACK_AWS_PROVIDER_ACCOUNT_PRO = 'account:pro',
  LOCALSTACK_AWS_PROVIDER_ACM_PCA_PRO = 'acm-pca:pro',
  LOCALSTACK_AWS_PROVIDER_AMPLIFY_PRO = 'amplify:pro',
  LOCALSTACK_AWS_PROVIDER_APIGATEWAY_LEGACY_PRO = 'apigateway:legacy_pro',
  LOCALSTACK_AWS_PROVIDER_APIGATEWAY_NEXT_GEN_PRO = 'apigateway:next_gen_pro',
  LOCALSTACK_AWS_PROVIDER_APIGATEWAY_PRO = 'apigateway:pro',
  LOCALSTACK_AWS_PROVIDER_APIGATEWAYMANAGEMENTAPI_LEGACY_PRO = 'apigatewaymanagementapi:legacy_pro',
  LOCALSTACK_AWS_PROVIDER_APIGATEWAYMANAGEMENTAPI_NEXT_GEN_PRO = 'apigatewaymanagementapi:next_gen_pro',
  LOCALSTACK_AWS_PROVIDER_APIGATEWAYMANAGEMENTAPI_PRO = 'apigatewaymanagementapi:pro',
  LOCALSTACK_AWS_PROVIDER_APIGATEWAYV2_LEGACY_PRO = 'apigatewayv2:legacy_pro',
  LOCALSTACK_AWS_PROVIDER_APIGATEWAYV2_NEXT_GEN_PRO = 'apigatewayv2:next_gen_pro',
  LOCALSTACK_AWS_PROVIDER_APIGATEWAYV2_PRO = 'apigatewayv2:pro',
  LOCALSTACK_AWS_PROVIDER_APPCONFIG_PRO = 'appconfig:pro',
  LOCALSTACK_AWS_PROVIDER_APPCONFIGDATA_PRO = 'appconfigdata:pro',
  LOCALSTACK_AWS_PROVIDER_APPLICATION_AUTOSCALING_PRO = 'application-autoscaling:pro',
  LOCALSTACK_AWS_PROVIDER_APPSYNC_PRO = 'appsync:pro',
  LOCALSTACK_AWS_PROVIDER_ATHENA_PRO = 'athena:pro',
  LOCALSTACK_AWS_PROVIDER_AUTOSCALING_PRO = 'autoscaling:pro',
  LOCALSTACK_AWS_PROVIDER_BACKUP_PRO = 'backup:pro',
  LOCALSTACK_AWS_PROVIDER_BATCH_PRO = 'batch:pro',
  LOCALSTACK_AWS_PROVIDER_BEDROCK_RUNTIME_PRO = 'bedrock-runtime:pro',
  LOCALSTACK_AWS_PROVIDER_BEDROCK_PRO = 'bedrock:pro',
  LOCALSTACK_AWS_PROVIDER_CE_PRO = 'ce:pro',
  LOCALSTACK_AWS_PROVIDER_CLOUDCONTROL_PRO = 'cloudcontrol:pro',
  LOCALSTACK_AWS_PROVIDER_CLOUDFORMATION_PRO = 'cloudformation:pro',
  LOCALSTACK_AWS_PROVIDER_CLOUDFORMATION_PRO_ENGINE_LEGACY = 'cloudformation:engine-legacy_pro',
  LOCALSTACK_AWS_PROVIDER_CLOUDFORMATION_PRO_ENGINE_V2 = 'cloudformation:engine-v2_pro',
  LOCALSTACK_AWS_PROVIDER_CLOUDFRONT_KEYVALUESTORE_PRO = 'cloudfront-keyvaluestore:pro',
  LOCALSTACK_AWS_PROVIDER_CLOUDFRONT_PRO = 'cloudfront:pro',
  LOCALSTACK_AWS_PROVIDER_CLOUDTRAIL_PRO = 'cloudtrail:pro',
  LOCALSTACK_AWS_PROVIDER_CODEARTIFACT_PRO = 'codeartifact:pro',
  LOCALSTACK_AWS_PROVIDER_CODEBUILD_PRO = 'codebuild:pro',
  LOCALSTACK_AWS_PROVIDER_CODECOMMIT_PRO = 'codecommit:pro',
  LOCALSTACK_AWS_PROVIDER_CODECONNECTIONS_PRO = 'codeconnections:pro',
  LOCALSTACK_AWS_PROVIDER_CODESTAR_CONNECTIONS_PRO = 'codestar-connections:pro',
  LOCALSTACK_AWS_PROVIDER_CODEDEPLOY_PRO = 'codedeploy:pro',
  LOCALSTACK_AWS_PROVIDER_CODEPIPELINE_PRO = 'codepipeline:pro',
  LOCALSTACK_AWS_PROVIDER_COGNITO_IDENTITY_PRO = 'cognito-identity:pro',
  LOCALSTACK_AWS_PROVIDER_COGNITO_IDP_PRO = 'cognito-idp:pro',
  LOCALSTACK_AWS_PROVIDER_DMS_PRO = 'dms:pro',
  LOCALSTACK_AWS_PROVIDER_DOCDB_PRO = 'docdb:pro',
  LOCALSTACK_AWS_PROVIDER_DSQL_PRO = 'dsql:pro',
  LOCALSTACK_AWS_PROVIDER_DYNAMODB_PRO = 'dynamodb:pro',
  LOCALSTACK_AWS_PROVIDER_DYNAMODB_V2_PRO = 'dynamodb:v2_pro',
  LOCALSTACK_AWS_PROVIDER_DYNAMODB_LEGACY_PRO = 'dynamodb:legacy_pro',
  LOCALSTACK_AWS_PROVIDER_EC2_PRO = 'ec2:pro',
  LOCALSTACK_AWS_PROVIDER_ECR_PRO = 'ecr:pro',
  LOCALSTACK_AWS_PROVIDER_ECS_PRO = 'ecs:pro',
  LOCALSTACK_AWS_PROVIDER_EFS_PRO = 'efs:pro',
  LOCALSTACK_AWS_PROVIDER_EKS_AUTH_PRO = 'eks-auth:pro',
  LOCALSTACK_AWS_PROVIDER_EKS_MOCK = 'eks:mock',
  LOCALSTACK_AWS_PROVIDER_EKS_PRO = 'eks:pro',
  LOCALSTACK_AWS_PROVIDER_ELASTICACHE_PRO = 'elasticache:pro',
  LOCALSTACK_AWS_PROVIDER_ELASTICBEANSTALK_PRO = 'elasticbeanstalk:pro',
  LOCALSTACK_AWS_PROVIDER_ELASTICTRANSCODER_PRO = 'elastictranscoder:pro',
  LOCALSTACK_AWS_PROVIDER_ELB_PRO = 'elb:pro',
  LOCALSTACK_AWS_PROVIDER_ELBV2_PRO = 'elbv2:pro',
  LOCALSTACK_AWS_PROVIDER_ELBV2_LEGACY = 'elbv2:legacy',
  LOCALSTACK_AWS_PROVIDER_EMR_SERVERLESS_PRO = 'emr-serverless:pro',
  LOCALSTACK_AWS_PROVIDER_EMR_PRO = 'emr:pro',
  LOCALSTACK_AWS_PROVIDER_EVENTS_LEGACY_PRO = 'events:legacy_pro',
  LOCALSTACK_AWS_PROVIDER_EVENTS_PRO = 'events:pro',
  LOCALSTACK_AWS_PROVIDER_EVENTS_V1_PRO = 'events:v1_pro',
  LOCALSTACK_AWS_PROVIDER_EVENTS_V2_PRO = 'events:v2_pro',
  LOCALSTACK_AWS_PROVIDER_FIS_PRO = 'fis:pro',
  LOCALSTACK_AWS_PROVIDER_GLACIER_PRO = 'glacier:pro',
  LOCALSTACK_AWS_PROVIDER_GLUE_PRO = 'glue:pro',
  LOCALSTACK_AWS_PROVIDER_IDENTITYSTORE_PRO = 'identitystore:pro',
  LOCALSTACK_AWS_PROVIDER_IOT_DATA_PRO = 'iot-data:pro',
  LOCALSTACK_AWS_PROVIDER_IOT_PRO = 'iot:pro',
  LOCALSTACK_AWS_PROVIDER_IOTWIRELESS_PRO = 'iotwireless:pro',
  LOCALSTACK_AWS_PROVIDER_KAFKA_PRO = 'kafka:pro',
  LOCALSTACK_AWS_PROVIDER_KAFKA_V2_PRO = 'kafka:v2_pro',
  LOCALSTACK_AWS_PROVIDER_KAFKA_LEGACY = 'kafka:legacy',
  LOCALSTACK_AWS_PROVIDER_KINESIS_PRO = 'kinesis:pro',
  LOCALSTACK_AWS_PROVIDER_KINESIS_LEGACY_PRO = 'kinesis:legacy_pro',
  LOCALSTACK_AWS_PROVIDER_KINESISANALYTICSV2_PRO = 'kinesisanalyticsv2:pro',
  LOCALSTACK_AWS_PROVIDER_KMS_PRO = 'kms:pro',
  LOCALSTACK_AWS_PROVIDER_LAKEFORMATION_PRO = 'lakeformation:pro',
  LOCALSTACK_AWS_PROVIDER_LAMBDA_ASF_PRO = 'lambda:asf_pro',
  LOCALSTACK_AWS_PROVIDER_LAMBDA_PRO = 'lambda:pro',
  LOCALSTACK_AWS_PROVIDER_LAMBDA_MICROVMS_PRO = 'lambda-microvms:pro',
  LOCALSTACK_AWS_PROVIDER_LAMBDA_V2_PRO = 'lambda:v2_pro',
  LOCALSTACK_AWS_PROVIDER_LOGS_PRO = 'logs:pro',
  LOCALSTACK_AWS_PROVIDER_LOGS_V1_PRO = 'logs:v1_pro',
  LOCALSTACK_AWS_PROVIDER_LOGS_V2_PRO = 'logs:v2_pro',
  LOCALSTACK_AWS_PROVIDER_MANAGEDBLOCKCHAIN_PRO = 'managedblockchain:pro',
  LOCALSTACK_AWS_PROVIDER_MEDIACONVERT_PRO = 'mediaconvert:pro',
  LOCALSTACK_AWS_PROVIDER_MEMORYDB_PRO = 'memorydb:pro',
  LOCALSTACK_AWS_PROVIDER_MQ_PRO = 'mq:pro',
  LOCALSTACK_AWS_PROVIDER_MWAA_PRO = 'mwaa:pro',
  LOCALSTACK_AWS_PROVIDER_NEPTUNE_PRO = 'neptune:pro',
  LOCALSTACK_AWS_PROVIDER_OPENSEARCH_PRO = 'opensearch:pro',
  LOCALSTACK_AWS_PROVIDER_ORGANIZATIONS_PRO = 'organizations:pro',
  LOCALSTACK_AWS_PROVIDER_PINPOINT_PRO = 'pinpoint:pro',
  LOCALSTACK_AWS_PROVIDER_PIPES_PRO = 'pipes:pro',
  LOCALSTACK_AWS_PROVIDER_RAM_PRO = 'ram:pro',
  LOCALSTACK_AWS_PROVIDER_RDS_DATA_PRO = 'rds-data:pro',
  LOCALSTACK_AWS_PROVIDER_RDS_PRO = 'rds:pro',
  LOCALSTACK_AWS_PROVIDER_REDSHIFT_DATA_PRO = 'redshift-data:pro',
  LOCALSTACK_AWS_PROVIDER_REDSHIFT_PRO = 'redshift:pro',
  LOCALSTACK_AWS_PROVIDER_ROUTE53_PRO = 'route53:pro',
  LOCALSTACK_AWS_PROVIDER_S3_PRO = 's3:pro',
  LOCALSTACK_AWS_PROVIDER_S3CONTROL_PRO = 's3control:pro',
  LOCALSTACK_AWS_PROVIDER_S3FILES_PRO = 's3files:pro',
  LOCALSTACK_AWS_PROVIDER_S3TABLES_PRO = 's3tables:pro',
  LOCALSTACK_AWS_PROVIDER_SAGEMAKER_RUNTIME_PRO = 'sagemaker-runtime:pro',
  LOCALSTACK_AWS_PROVIDER_SAGEMAKER_PRO = 'sagemaker:pro',
  LOCALSTACK_AWS_PROVIDER_SERVERLESSREPO_PRO = 'serverlessrepo:pro',
  LOCALSTACK_AWS_PROVIDER_SERVICEDISCOVERY_PRO = 'servicediscovery:pro',
  LOCALSTACK_AWS_PROVIDER_SES_PRO = 'ses:pro',
  LOCALSTACK_AWS_PROVIDER_SESV2_PRO = 'sesv2:pro',
  LOCALSTACK_AWS_PROVIDER_SHIELD_PRO = 'shield:pro',
  LOCALSTACK_AWS_PROVIDER_SQS_PRO = 'sqs:pro',
  LOCALSTACK_AWS_PROVIDER_SSM_PRO = 'ssm:pro',
  LOCALSTACK_AWS_PROVIDER_SSO_ADMIN_PRO = 'sso-admin:pro',
  LOCALSTACK_AWS_PROVIDER_STS_PRO = 'sts:pro',
  LOCALSTACK_AWS_PROVIDER_TEXTRACT_PRO = 'textract:pro',
  LOCALSTACK_AWS_PROVIDER_TIMESTREAM_QUERY_PRO = 'timestream-query:pro',
  LOCALSTACK_AWS_PROVIDER_TIMESTREAM_WRITE_PRO = 'timestream-write:pro',
  LOCALSTACK_AWS_PROVIDER_TRANSFER_PRO = 'transfer:pro',
  LOCALSTACK_AWS_PROVIDER_VERIFIED_PERMISSIONS_PRO = 'verifiedpermissions:pro',
  LOCALSTACK_AWS_PROVIDER_WAFV2_PRO = 'wafv2:pro',
  LOCALSTACK_AWS_PROVIDER_XRAY_PRO = 'xray:pro',
  LOCALSTACK_AWS_PROVIDER_SNOWFLAKE_PRO = 'snowflake:pro',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "LocalstackContainerRuntime".
 */
export const enum LocalstackContainerRuntime {
  LOCALSTACK_CONTAINER_RUNTIME_DOCKER = 'docker',
  LOCALSTACK_CONTAINER_RUNTIME_KUBERNETES = 'kubernetes',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "LocalstackGlueJobExecutor".
 */
export const enum LocalstackGlueJobExecutor {
  LOCALSTACK_GLUE_JOB_EXECUTOR_LOCAL = 'local',
  LOCALSTACK_GLUE_JOB_EXECUTOR_DOCKER = 'docker',
  LOCALSTACK_GLUE_JOB_EXECUTOR_KUBERNETES = 'kubernetes',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "LocalstackLambdaRuntimeExecutor".
 */
export const enum LocalstackLambdaRuntimeExecutor {
  LOCALSTACK_LAMBDA_RUNTIME_EXECUTOR_DOCKER = 'docker',
  LOCALSTACK_LAMBDA_RUNTIME_EXECUTOR_KUBERNETES = 'kubernetes',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "LocalstackPlatformPlugin".
 */
export const enum LocalstackPlatformPlugin {
  LOCALSTACK_PLATFORM_PLUGIN_APPINSPECTOR = 'appinspector',
  LOCALSTACK_PLATFORM_PLUGIN_CERTIFICATES = 'certificates',
  LOCALSTACK_PLATFORM_PLUGIN_CHAOS = 'chaos',
  LOCALSTACK_PLATFORM_PLUGIN_CHAOS_BASIC = 'chaos-basic',
  LOCALSTACK_PLATFORM_PLUGIN_ECS_FIRELENS = 'ecs-firelens',
  LOCALSTACK_PLATFORM_PLUGIN_ECS_K8S_TASK_EXECUTOR = 'ecs-k8s-task-executor',
  LOCALSTACK_PLATFORM_PLUGIN_FIS_EMULATION = 'fis-emulation',
  LOCALSTACK_PLATFORM_PLUGIN_IAM_ENFORCEMENT = 'iam-enforcement',
  LOCALSTACK_PLATFORM_PLUGIN_IAM_STREAM = 'iam-stream',
  LOCALSTACK_PLATFORM_PLUGIN_LAMBDA_ESM_KAFKA = 'lambda-esm-kafka',
  LOCALSTACK_PLATFORM_PLUGIN_LAMBDA_LDM = 'lambda-ldm',
  LOCALSTACK_PLATFORM_PLUGIN_NON_DEFAULT_PARTITIONS = 'non-default-partitions',
  LOCALSTACK_PLATFORM_PLUGIN_POD_ENCRYPTION = 'pod-encryption',
  LOCALSTACK_PLATFORM_PLUGIN_REPLICATOR = 'replicator',
  LOCALSTACK_PLATFORM_PLUGIN_PODS = 'pods',
  LOCALSTACK_PLATFORM_PLUGIN_SNAPSHOT = 'snapshot',
  LOCALSTACK_PLATFORM_PLUGIN_STATE_RESET = 'state-reset',
  LOCALSTACK_PLATFORM_PLUGIN_EXTENSIONS = 'extensions',
  LOCALSTACK_PLATFORM_PLUGIN_TRANSPARENT_ENDPOINT_INJECTION = 'transparent-endpoint-injection',
  LOCALSTACK_PLATFORM_PLUGIN_ENFORCE_TELEMETRY = 'enforce-telemetry',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "LocalstackPodsRemote".
 */
export const enum LocalstackPodsRemote {
  LOCALSTACK_PODS_REMOTE_ORAS = 'oras',
  LOCALSTACK_PODS_REMOTE_PLATFORM = 'platform',
  LOCALSTACK_PODS_REMOTE_S3 = 's3',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "MembershipActionBlockedReason".
 */
export const enum MembershipActionBlockedReason {
  SELF = 'self',
  MISSING_PERMISSION = 'missing_permission',
  ROLE_HIERARCHY = 'role_hierarchy',
  SCIM_MANAGED = 'scim_managed',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "MembershipRole".
 */
export const enum MembershipRole {
  ADMIN = 'admin',
  MEMBER = 'member',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "MetricStatus".
 */
export const enum MetricStatus {
  SUCCESS = 'success',
  ERROR = 'error',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "ModelAttributeChangeType".
 */
export const enum ModelAttributeChangeType {
  ADD = 'add',
  REMOVE = 'remove',
  REPLACE = 'replace',
  COPY = 'copy',
  MOVE = 'move',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "NewsletterSignupOrigin".
 */
export const enum NewsletterSignupOrigin {
  ACCOUNT_CREATION = 'account_creation',
  COCKPIT_DOWNLOAD = 'cockpit_download',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "OrganizationRestrictionReason".
 */
export const enum OrganizationRestrictionReason {
  FREEMIUM_HOBBY_COMMERCIAL_MISUSE = 'freemium_hobby_commercial_misuse',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "Permission".
 */
export const enum Permission {
  READ_CREDIT_CARDS = 'read.credit_cards',
  CREATE_CREDIT_CARDS = 'create.credit_cards',
  READ_SUBSCRIPTIONS = 'read.subscriptions',
  CREATE_SUBSCRIPTIONS = 'create.subscriptions',
  UPDATE_SUBSCRIPTIONS = 'update.subscriptions',
  DELETE_SUBSCRIPTIONS = 'delete.subscriptions',
  READ_MEMBERS = 'read.members',
  CREATE_MEMBERS = 'create.members',
  UPDATE_MEMBERS = 'update.members',
  DELETE_MEMBERS = 'delete.members',
  READ_INVOICES = 'read.invoices',
  UPDATE_ORGANIZATION = 'update.organization',
  DELETE_ORGANIZATION = 'organization:delete',
  LIST_LICENSES = 'licenses:list',
  ASSIGN_LICENSES = 'licenses:assign',
  UNASSIGN_LICENSES = 'licenses:unassign',
  SELF_ISSUE_LICENSE = 'licenses:issue_self',
  WRITE_CI_TOKENS = 'ci-tokens:write',
  READ_CI_TOKENS = 'ci-tokens:read',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "PlanInterval".
 */
export const enum PlanInterval {
  YEARS = 'years',
  MONTHS = 'months',
  WEEKS = 'weeks',
  DAYS = 'days',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "PlatformErrorCode".
 */
export const enum PlatformErrorCode {
  CLOUD_POD_SHOULD_BE_ENCRYPTED = 'Cloud Pod should be encrypted',
  CLOUD_POD_SHOULD_NOT_BE_ENCRYPTED = 'Cloud Pod should not be encrypted',
  CLOUD_POD_NOT_FOUND = 'Cloud pod not found',
  CLOUD_POD_REQUIRES_A_NON_EMPTY_NAME = 'Cloud pod requires a non-empty name',
  CLOUD_POD_WITH_THE_SAME_NAME_ALREADY_EXISTS = 'Cloud pod with the same name already exists',
  COULD_NOT_FIND_ASSET_ASSET_NAME_FOR_CLOUD_POD_POD_NAME_VERSION_VERSION = "Could not find asset {asset_name} for cloud pod '{pod_name}' version {version}",
  INSTANCE_LIFETIME_CAN_NOT_EXCEED_120_MINUTES = 'Instance lifetime can not exceed 120 minutes',
  INSTANCE_NAME_IS_REQUIRED_AND_ONLY_ALLOWS_ALPHANUMERIC_VALUES_AND_HYPHENS = 'Instance name is required and only allows alphanumeric values and hyphens',
  INVALID_NAME_FOR_CLOUD_POD = 'Invalid name for cloud pod',
  NEW_VERSION_VERSION_NEEDS_TO_BE_HIGHER_THAN_THE_CURRENT_LATEST_VERSION_MAX_VERSION = 'New version ({version}) needs to be higher than the current latest version ({max_version})',
  REQUESTED_VERSIONS_ARE_NOT_VALID = 'Requested versions are not valid',
  SHUTDOWN_TIMEOUT_MUST_BE_BETWEEN_1_AND_600_SECONDS = 'Shutdown timeout must be between 1 and 600 seconds',
  STORAGE_SIZE_EXCEEDED = 'Storage size exceeded',
  VERSION_NUMBER_NEEDS_TO_BE_SPECIFIED = 'Version number needs to be specified',
  ACCESS_RESTRICTED = 'access.restricted',
  ADMIN_ERROR = 'admin.error',
  ANALYTICS_GENERAL_ERROR = 'analytics.general_error',
  ANALYTICS_INVALID_ARGUMENT = 'analytics.invalid_argument',
  ANALYTICS_NOT_FOUND = 'analytics.not_found',
  ANALYTICS_RESOURCE_EXHAUSTED = 'analytics.resource_exhausted',
  ANALYTICS_SERVICE_UNAVAILABLE = 'analytics.service_unavailable',
  AUTH_ADMIN_EXISTS = 'auth.admin_exists',
  AUTH_ADMIN_NOT_FOUND = 'auth.admin_not_found',
  AUTH_ADMIN_NOT_LOCALSTACK_EMAIL = 'auth.admin_not_localstack_email',
  AUTH_ADMIN_UNIDENTIFIED_USER = 'auth.admin_unidentified_user',
  AUTH_AUTH_REQUEST = 'auth.auth_request',
  AUTH_CREATE_IDENTITY = 'auth.create_identity',
  AUTH_DELETE_LINK = 'auth.delete_link',
  AUTH_EMAIL_FORMAT = 'auth.email_format',
  AUTH_ERROR = 'auth.error',
  AUTH_IDENTITY_EXISTS = 'auth.identity_exists',
  AUTH_INVALID_GRANT = 'auth.invalid_grant',
  AUTH_MISSING_INITIATOR = 'auth.missing_initiator',
  AUTH_NOT_ACTIVATED = 'auth.not_activated',
  AUTH_SAME_CREDENTIALS = 'auth.same_credentials',
  AUTH_TOKEN_REFRESH = 'auth.token_refresh',
  AUTH_UPDATE_CREDENTIALS = 'auth.update_credentials',
  AUTH_WEAK_CREDENTIALS = 'auth.weak_credentials',
  AZURE_MARKETPLACE_ACTIVATION_FAILED = 'azure_marketplace.activation_failed',
  AZURE_MARKETPLACE_AUTH_FAILED = 'azure_marketplace.auth_failed',
  AZURE_MARKETPLACE_INVALID_TOKEN = 'azure_marketplace.invalid_token',
  AZURE_MARKETPLACE_REQUEST_FAILED = 'azure_marketplace.request_failed',
  AZURE_MARKETPLACE_SUBSCRIPTION_NOT_FOUND = 'azure_marketplace.subscription_not_found',
  BILLING_CARD_DECLINED = 'billing.card_declined',
  BILLING_CARD_NOT_FOUND = 'billing.card_not_found',
  COMPUTE_ALREADY_EXISTS = 'compute.already_exists',
  COMPUTE_CONTAINER_STARTUP_FAILED = 'compute.container_startup_failed',
  COMPUTE_FAILED_PRECONDITION = 'compute.failed_precondition',
  COMPUTE_GENERAL_ERROR = 'compute.general_error',
  COMPUTE_INVALID_ARGUMENT = 'compute.invalid_argument',
  COMPUTE_MISSING_TOKEN = 'compute.missing_token',
  COMPUTE_NOT_FOUND = 'compute.not_found',
  COMPUTE_RESOURCE_EXHAUSTED = 'compute.resource_exhausted',
  COMPUTE_SERVICE_UNAVAILABLE = 'compute.service_unavailable',
  EXTENSIONS_DUPLICATE_PLUGIN_NAME = 'extensions.duplicate_plugin_name',
  EXTENSIONS_PACKAGE_NOT_FOUND = 'extensions.package_not_found',
  GENERIC_BAD_REQUEST = 'generic.bad_request',
  GENERIC_FORBIDDEN = 'generic.forbidden',
  GENERIC_GATEWAY_TIMEOUT = 'generic.gateway_timeout',
  GENERIC_NOT_FOUND = 'generic.not_found',
  GENERIC_UNAUTHORISED = 'generic.unauthorised',
  GENERIC_UNHANDLED = 'generic.unhandled',
  GENERIC_UNPROCESSABLE = 'generic.unprocessable',
  GITHUB_STUDENT_VERIFICATION_BAD_VERIFICATION_CODE = 'github_student_verification.bad_verification_code',
  GITHUB_STUDENT_VERIFICATION_SUB_EXIST = 'github_student_verification.sub_exist',
  IDENTITY_INVALID_TOKEN = 'identity.invalid_token',
  IDENTITY_MALFORMED_IDENTITY = 'identity.malformed_identity',
  IDENTITY_NOT_FOUND = 'identity.not_found',
  IDENTITY_UNKNOWN_ERROR = 'identity.unknown_error',
  IDENTITY_POLICY_DOMAIN_RESTRICTED_SSO_VIOLATION = 'identity_policy.domain_restricted_sso.violation',
  IDENTITY_POLICY_EMAIL_ALIAS_FORBIDDEN = 'identity_policy.email.alias_forbidden',
  IDENTITY_POLICY_EMAIL_DISPOSABLE_FORBIDDEN = 'identity_policy.email.disposable_forbidden',
  IDENTITY_POLICY_EMAIL_EXISTS = 'identity_policy.email.exists',
  IDENTITY_POLICY_EMAIL_FORBIDDEN = 'identity_policy.email.forbidden',
  IDENTITY_POLICY_PASSWORD_INVALID_FORMAT = 'identity_policy.password.invalid_format',
  IDENTITY_POLICY_PASSWORD_WEAK_PASSWORD = 'identity_policy.password.weak_password',
  IDENTITY_POLICY_STRICT_SSO_VIOLATION = 'identity_policy.strict_sso.violation',
  IDENTITY_POLICY_TAKEOVER_PROTECTION_VIOLATION = 'identity_policy.takeover_protection.violation',
  IDP_INVALID_NAME = 'idp.invalid_name',
  KEYS_DEPRECATED = 'keys.deprecated',
  KEYS_ROTATED_OR_DELETED = 'keys.rotated_or_deleted',
  LICENSE_GENERIC_ERROR = 'license.generic_error',
  LICENSING_ACTIVATION_ERROR = 'licensing.activation_error',
  LICENSING_ALL_SEATS_ALREADY_ASSIGNED_ERROR = 'licensing.all_seats_already_assigned_error',
  LICENSING_CREDENTIALS_EXISTS = 'licensing.credentials.exists',
  LICENSING_CREDENTIALS_FORMAT = 'licensing.credentials.format',
  LICENSING_CREDENTIALS_INVALID = 'licensing.credentials.invalid',
  LICENSING_CREDENTIALS_NOT_FOUND = 'licensing.credentials.not_found',
  LICENSING_DUPLICATE_EMULATOR_TYPE = 'licensing.duplicate_emulator_type',
  LICENSING_DUPLICATE_SUBSCRIPTION = 'licensing.duplicate_subscription',
  LICENSING_EMULATOR_TYPE_NOT_SUPPORTED = 'licensing.emulator_type_not_supported',
  LICENSING_INVALID_ORG_ID = 'licensing.invalid_org_id',
  LICENSING_LATEST_VERSION_NOT_FOUND = 'licensing.latest_version_not_found',
  LICENSING_LICENSE_EXPIRED = 'licensing.license.expired',
  LICENSING_LICENSE_NOT_ASSIGNED = 'licensing.license.not_assigned',
  LICENSING_LICENSE_NOT_ENOUGH_CREDITS = 'licensing.license.not_enough_credits',
  LICENSING_LICENSE_NOT_FOUND = 'licensing.license.not_found',
  LICENSING_LICENSE_PRODUCT_ERROR = 'licensing.license.product_error',
  LICENSING_MISSING_ORGANIZATION_ID = 'licensing.missing_organization_id',
  LICENSING_MISSING_SUBSCRIPTION = 'licensing.missing_subscription',
  LICENSING_PRODUCT_FORMAT = 'licensing.product.format',
  LICENSING_USER_NOT_FOUND = 'licensing.user_not_found',
  MARKETPLACE_DIFFERENT_LINK_EXISTS = 'marketplace.different_link_exists',
  MARKETPLACE_SAME_LINK_EXISTS = 'marketplace.same_link_exists',
  MARKETPLACE_SUB_EVENT_NOT_FOUND = 'marketplace.sub_event_not_found',
  MARKETPLACE_SUBSCRIPTION_ALREADY_EXISTS = 'marketplace.subscription_already_exists',
  MEMBERSHIP_ALREADY_IN_ORG = 'membership.already_in_org',
  MEMBERSHIP_INVALID_ACCEPT_IN_FREE_WORKSPACE = 'membership.invalid_accept_in_free_workspace',
  MEMBERSHIP_INVALID_ORG = 'membership.invalid_org',
  MEMBERSHIP_NOT_FOUND = 'membership.not_found',
  MEMBERSHIP_PASSWORD_REQUIRED = 'membership.password_required',
  NOTIFICATION_RECOVERY_INFO_MISSING = 'notification.recovery_info_missing',
  ORG_DELETE_WITH_ACTIVE_SUBSCRIPTIONS_ERROR = 'org.delete_with_active_subscriptions_error',
  ORG_DELETE_WITH_LAST_WORKSPACE = 'org.delete_with_last_workspace',
  ORG_LICENSE_ALREADY_ASSIGNED_ERROR = 'org.license_already_assigned_error',
  ORG_NO_TARGET_SUBSCRIPTION_ERROR = 'org.no_target_subscription_error',
  ORGANIZATION_NOT_FOUND = 'organization.not_found',
  PROMOTION_NOT_APPLICABLE = 'promotion.not_applicable',
  PROMOTION_NOT_FOUND = 'promotion.not_found',
  PROMOTION_UNAVAILABLE = 'promotion.unavailable',
  RECAPTCHA_VERIFICATION = 'recaptcha.verification',
  SCIM_BAD_REQUEST = 'scim.bad_request',
  SCIM_ERROR = 'scim.error',
  SCIM_TOKEN_EXISTS = 'scim.token_exists',
  SCIM_TOKEN_GENERATION_FAILED = 'scim.token_generation_failed',
  SCIM_TOKEN_NOT_FOUND = 'scim.token_not_found',
  SUBSCRIPTION_FREEMIUM_SUB_IN_MULTI_MEMBERS_ORG = 'subscription.freemium_sub_in_multi_members_org',
  SUBSCRIPTION_NOT_FOUND = 'subscription.not_found',
  SUBSCRIPTION_REACTIVATE = 'subscription.reactivate',
  SUBSCRIPTION_SUBSCRIBE = 'subscription.subscribe',
  SUBSCRIPTION_UNHANDLED = 'subscription.unhandled',
  SUBSCRIPTION_UNSUBSCRIBE = 'subscription.unsubscribe',
  SUBSCRIPTION_UPDATE = 'subscription.update',
  USER_LEAVE_LAST_WORKSPACE_ERROR = 'user.leave_last_workspace_error',
  USER_NOT_FOUND = 'user.not_found',
  USER_PASSWORD_RECOVERY = 'user.password_recovery',
  USER_PASSWORD_UPDATE_ERROR = 'user.password_update_error',
  USER_INVITATION_INELIGIBLE = 'user_invitation.ineligible',
  USER_INVITATION_NOT_FOUND = 'user_invitation.not_found',
  USER_MEMBERSHIP_MEMBERSHIP_ALREADY_EXISTS = 'user_membership.membership_already_exists',
  USER_MEMBERSHIP_MEMBERSHIP_NOT_FOUND = 'user_membership.membership_not_found',
  USER_MEMBERSHIP_MEMBERSHIP_VIEW_BUILD_ERROR = 'user_membership.membership_view_build_error',
  USER_MEMBERSHIP_PERMISSION_ESCALATION_ERROR = 'user_membership.permission_escalation_error',
  USER_MEMBERSHIP_PRIMARY_MEMBERSHIP_NOT_SET = 'user_membership.primary_membership_not_set',
  USER_MEMBERSHIP_ROLE_HIERARCHY_ERROR = 'user_membership.role_hierarchy_error',
  USER_MEMBERSHIP_SCIM_MANAGED_ERROR = 'user_membership.scim_managed_error',
  USER_MEMBERSHIP_SELF_MEMBERSHIP_DELETION_ERROR = 'user_membership.self_membership_deletion_error',
  USER_MEMBERSHIP_SELF_MEMBERSHIP_UPDATE_ERROR = 'user_membership.self_membership_update_error',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "PodStorageEventTrigger".
 */
export const enum PodStorageEventTrigger {
  PUT = 'PUT',
  DELETE = 'DELETE',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "ProductFeature".
 */
export const enum ProductFeature {
  FEATURE_SCIM = 'localstack.scim',
  FEATURE_SSO = 'localstack.sso',
  FEATURE_USAGE_INSIGHTS = 'localstack.usage_insights',
  FEATURE_STACKS_PREVIEW = 'localstack.stacks.preview',
  FEATURE_STACKS_PREMIUM = 'localstack.stacks.premium',
  FEATURE_COMPUTE = 'localstack.compute',
  FEATURE_PODS = 'localstack.pods',
  FEATURE_PODS_PUBLIC = 'localstack.pods.public',
  FEATURE_LOCALSTACK_EXTENSION = 'localstack.extensions',
  FEATURE_LOCALSTACK_PRO = 'localstack-pro',
  FEATURE_LOCALSTACK_APPINSPECTOR = 'localstack.appinspector',
  FEATURE_LOCALSTACK_AWS_PROVIDER = 'localstack.aws.provider',
  FEATURE_LOCALSTACK_PLUGIN = 'localstack.platform.plugin',
  FEATURE_LOCALSTACK_CONTAINER_RUNTIME = 'localstack.container.runtime',
  FEATURE_LOCALSTACK_GLUE_JOB_EXECUTOR = 'localstack.glue.job_executor',
  FEATURE_LOCALSTACK_LAMBDA_RUNTIME_EXECUTOR = 'localstack.lambda.runtime_executor',
  FEATURE_LOCALSTACK_PODS_REMOTE = 'localstack.pods.remote',
  FEATURE_LOCALSTACK_K8S_OPERATOR = 'localstack.k8s.operator',
  FEATURE_SNOWFLAKE = 'localstack.snowflake',
  FEATURE_PLATFORM_LOGGING = 'localstack.platform.logging',
  FEATURE_CI_PROJECTS = 'localstack.ci_projects',
  FEATURE_AZURE_PREVIEW = 'localstack.azure.preview',
  FEATURE_SNOWFLAKE_RUST_PREVIEW = 'localstack.snowflake.rust.preview',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "Service".
 */
export const enum Service {
  LOCALSTACK = 'localstack',
  FLASK = 'flask',
  SMTP = 'smtp',
  STRIPE = 'stripe',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "SortDirection".
 */
export const enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "SubscriptionStatus".
 */
export const enum SubscriptionStatus {
  INCOMPLETE = 'incomplete',
  INCOMPLETE_EXPIRED = 'incomplete_expired',
  TRIALING = 'trialing',
  ACTIVE = 'active',
  PAST_DUE = 'past_due',
  CANCELED = 'canceled',
  UNPAID = 'unpaid',
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "SubscriptionType".
 */
export const enum SubscriptionType {
  MARKETING_INFORMATION = 159704750,
  ONE_TO_ONE = 160786218,
}
/**
 * This interface was referenced by `Models`'s JSON-Schema
 * via the `definition` "UsageInsightSortField".
 */
export const enum UsageInsightSortField {
  USER_ID = 'user_id',
  EMULATOR = 'emulator',
  EMAIL = 'email',
  FULL_NAME = 'full_name',
  ROLE = 'role',
  TIER = 'tier',
  LAST_ACTIVE_DATE = 'last_active_date',
}
